export function downloadFileFromUrl(url: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  (document.body || document.documentElement).appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
};

export default function downloadFileFromBase64(base64: string, fileName: string = 'File'): void {
  var a = document.createElement('a');
  if (a.click) {
    a.href = base64;
    a.target = '_parent';
    if ('download' in a) {
      a.download = fileName;
    }
    (document.body || document.documentElement).appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
  } else {
    if (window.top === window && base64.split('#')[0] === window.location.href.split('#')[0]) {
      var padCharacter = base64.indexOf('?') === -1 ? '?' : '&';
      base64 = base64.replace(/#|$/, padCharacter + '$&');
    }
    window.open(base64, '_parent');
  }
};
